export enum Message {
    VERIFY_CODE_SENT = "VERIFY_CODE_SENT",
    SIGN_IN_PROFILE = "SIGN_IN_PROFILE",
    SIGN_OUT_PROFILE = "SIGN_OUT_PROFILE",
    CHANGE_PASSWORD = "CHANGE_PASSWORD",
    RESET_PASSWORD_LINK = "RESET_PASSWORD_LINK",
    CHANGE_USERNAME = "CHANGE_USERNAME",
    UPDATE_PROFILE = "UPDATE_PROFILE",
    CREATE_RECORD = "CREATE_RECORD",
    CREATE_RECORDS = "CREATE_RECORDS",
    UPDATE_RECORD = "UPDATE_RECORD",
    UPDATE_RECORDS = "UPDATE_RECORDS",
    DELETE_RECORD = "DELETE_RECORD",
    DELETE_FILE = "DELETE_FILE",
    UPLOAD_SUCCESS = "UPLOAD_SUCCESS",
    UPLOAD_ERROR = "UPLOAD_ERROR",
    COPY_CLIPBOARD = "COPY_CLIPBOARD",
}

export enum Payment {
    Sep = 'SEP',
    Pep = 'PEP',
    Sadad = 'SADAD',
    Zarinpal = 'ZARINPAL',
}

export enum InvoiceComponent {
    Filter = 'FILTER',
    Add = 'ADD',
}

export enum UserComponent {
    CURecord = 'CU_RECORD',
    AddRole = 'ADD_ROLE',
}

export enum RoleComponent {
    CURecord = 'CU_RECORD',
    AddPermission = 'ADD_PERMISSION',
}

export enum UsernameType {
    Mobile = 'mobile',
    Email = 'email',
}

export enum Component {
    Filter = 'FILTER',
    View = 'VIEW',
}

export enum HostFile {
    Favicon = 'favicon',
    VerticalLogo = 'verticalLogo',
    HorizontalLogo = 'horizontalLogo',
}
